/**
 * Clean an array with duplicated values
 */
const Unique = array => {
  const a = array.concat()

  for (let i = 0; i < a.length; ++i) {
    for (let j = i + 1; j < a.length; ++j) {
      if (a[i] === a[j]) {
        a.splice(j--, 1)
      }
    }
  }
  return a
}

/**
 * Convert to Object
 */
export const inverse = obj => {
  const retobj = {}

  for (const key in obj) {
    retobj[obj[key]] = parseInt(key, 10)
  }
  return retobj
}

export default Unique
